import { render, staticRenderFns } from "./CompanyQaBlock.vue?vue&type=template&id=6cd89237&scoped=true"
import script from "./CompanyQaBlock.vue?vue&type=script&lang=js"
export * from "./CompanyQaBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd89237",
  null
  
)

export default component.exports